import { ExcelService } from './../../_services/excel.service';
import { AddToTalentpoolComponent } from './../../talentpool/add-to-talentpool/add-to-talentpool.component';
import { TalentpoolService } from './../../_services/talentpool.service';
import { CandidateService } from './../../_services/candidate.service';
import { Component, EventEmitter, OnInit, Output, TemplateRef, ViewChild, Inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CandidateNoteComponent } from '../candidate-note/candidate-note.component';
import { CandidateEmailComponent } from '../candidate-email/candidate-email.component';
import { Subject } from 'rxjs';
import { CreateTalentpoolComponent } from 'src/app/talentpool/create-talentpool/create-talentpool.component';
import * as _ from 'underscore';
import * as __ from 'lodash';
import { GlobalService } from 'src/app/_services/global.service';
import { CallLogComponent } from '../call-log/call-log.component';
import { LocalStorageService } from 'src/app/_services/local-storage.service';
import { TransactionService } from 'src/app/_services/transaction.service';
import * as moment from 'moment';
import { CandidateTagsComponent } from '../candidate-tags/candidate-tags.component';
import { PersonSearchService } from 'src/app/_services/person-search.service';
import { CampaignService } from 'src/app/_services/campaign.service';
import { campaignModel } from 'src/app/model/campaign';
import { FormControl, Validators } from '@angular/forms';
import { DOCUMENT } from '@angular/common';
import { BulkRevealModalComponent } from 'src/app/bulk-reveal-modal/bulk-reveal-modal.component';
import { isArray } from 'util';
import { EmailsettingsService } from 'src/app/_services/emailsettings.service';

import { CreateCandidateComponent } from '../create-candidate/create-candidate.component'
import { CreateCandidateNewComponent } from '../create-candidate-new/create-candidate-new.component';


@Component({
  selector: 'app-candidate-list',
  templateUrl: './candidate-list.component.html',
  styleUrls: ['./candidate-list.component.scss'],
  providers: [ExcelService]
})
export class CandidateListComponent implements OnInit {

  talentpoolid: any;
  talentpoolview: boolean;
  candidatelist: any[] = [];
  parentSubject: Subject<any> = new Subject();
  removeSubject: Subject<any> = new Subject();
  talentpoolslist: any[] = []
  talentpooldetails: any;
  successMessage: string;
  errorMessage: string;
  selectedcandidate: any[] = []
  sortBy: string = 'new';
  recent: boolean = true;
  oldest: boolean;
  updateon: any;
  candidateTotalCount: any;
  /** Store all candidate numbers received in API resp */
  totalBulkCandidatesNumber: string[] = [];
  isBulkSelect: boolean = false;
  /** Store all candidates numbers which have been unselected AFTER bulk select via checkbox */
  excludedCandidatesAfterBulkSelect: string[] = [];
  /** Selected option from download CSV modal */
  bulkDownloadCSVSelectedOption: 'currentPage' | 'All' = null;
  /** Flag to determine CSV processing is ongoing */
  processingCSVDownload: boolean = false;
  selected: boolean;
  totalcandidatecount: any;
  talent_option: any = 'all';
  appliedFilters: any = {};
  emailFoundCount: number = 0;

  candidatesWithoutContactNumber: number = 0;

  @ViewChild('noEmailModal') noEmailModal: TemplateRef<any>
  @ViewChild('successModal') successModal: TemplateRef<any>;
  @ViewChild('errorModal') errorModal: TemplateRef<any>;
  @ViewChild('deleteTalentpool') deleteTalentpool: TemplateRef<any>;
  @ViewChild('removeCandidatefromTalentpool') removeCandidatefromTalentpool: TemplateRef<any>;
  @ViewChild('addCandidateToEmailCampaign') addCandidateToEmailCampaign: TemplateRef<any>;
  @ViewChild('noCreditsSE') noCreditsSE: TemplateRef<any>;
  @ViewChild('upgradePlan') upgradePlan: TemplateRef<any>;
  @ViewChild('bulkemailerlimit') bulkemailerlimit: TemplateRef<any>;
  /** Bulk download as CSV modal ref */
  @ViewChild('bulkDownloadAsCSVModal') bulkDownloadAsCSVModal: TemplateRef<any>;

  start: number = 0;
  end: number = 0;
  total: any = 0;
  talentpipelinestates: any;
  coldtalent: any[] = [];
  warmtalent: any[] = [];
  hottalent: any[] = [];
  candidatedetails: any[] = [];
  contactdetails: any;
  talent_count: any;
  plandetails: string;
  subscriptiondetails: any = {};
  isteamMember: boolean;
  currentFilters: any = []
  talentpoolnumber: any;
  isprofile: boolean = true
  isinsights: boolean
  currentexprience: any = []
  selectedcandidateForNote : any = []
  sortby: string
  pageNumber: number = 1;
  pageSize: number = 10;
  currentPage: number = 1;
  @Output() candidateEvent: EventEmitter<any> = new EventEmitter();
  candidateSubject:Subject<any> = new Subject();
  @Output() talenpoolrefreshEvent: EventEmitter<any> = new EventEmitter();
  @Output() talenttabsrefreshEvent: EventEmitter<any> = new EventEmitter();

  viewMore:boolean = false; 
  showLookingForMore: boolean = false;
  appliedfiltercount: number;
  isSharedTalentpool: boolean = false;

  primaryCompanyInformation: any;
  currentCompanyInformation = {}
  campaignList: campaignModel[];
  campaign_input= new FormControl(null, [Validators.required]);
  selectedCampaign:{campaign_name : string, campaign_id : number};
  showLoaderOnCandidateList: Boolean = false;
  isCandidateSelected: boolean = false;

  /**Used for bulk reveal source key */
  enrichedFromForReveal: string = 'talenpool';
  /** To know the pending status of api*/
  isLoadingEmailCampaignApi: boolean = false;

  /**Bulk Reveal is in process or not */
  isBulkRevealInProcess: boolean = false;
  userEmailId: string = '';
  /**
   * Candidates without personal email or without contact number
   */
  candidatesWithoutContactInfo: number = 0;
  currentUser: any = null;

  /**
   * Data of Candidates which are selected for bulk reveal
   * Used to send data in Bulk Reveal Modal
   */
  selectedCandidateData: any = [];

  /**First name of user */
  firstNameUser: string = '';

  /**static messaging on top, regarding bulk reveal on talentpool level */
  bulkRevealBannerTalentpoolLevel: any = { showBanner: false, user: '', candidateCount: 0 };

  constructor(private router: Router, public modalService: NgbModal, public candidateservice: CandidateService, public talentpoolservice: TalentpoolService,private personSearchService:PersonSearchService,
    private _localstorageservice: LocalStorageService,private excel :ExcelService ,private transactionservice : TransactionService,private route: ActivatedRoute, private emailCampaignService: CampaignService,
    private emailsettings: EmailsettingsService, @Inject(DOCUMENT) private document: Document) { 
      this.currentUser = parseInt(this._localstorageservice.getItem('userid') || 0);
    }

  ngOnInit() {

    this.firstNameUser = this._localstorageservice.getItem('userdata')['firstname'];

    // this.currentFilters.push('3')
    
   // this.fetchcredits()
    this.candidateservice.GetCreatedCandidateData().subscribe(event => {
      this.talent_option = 'all'
     // this.getTalentpoolList()
    })

    this.talentpoolid = this.route.snapshot.params['id'];
    this.talentpoolservice.talentPoolDetails.subscribe((talentPoolData) => {
      this.talentpoolslist = talentPoolData ? talentPoolData.talentpools : [];
    });
    if(this.talentpoolid) {
        const currentTalentpoolDetails = this.talentpoolslist ? this.talentpoolslist.filter((x) => { return x.talentpoolid == this.talentpoolid })[0] : null;
        if(currentTalentpoolDetails) {
          this.talentpooldetails = currentTalentpoolDetails;
        } else {
          this.isSharedTalentpool = true;
          const sharedTalentPoolData = this._localstorageservice.getItem('sharedTalentPoolDetails') ? JSON.parse(this._localstorageservice.getItem('sharedTalentPoolDetails')) : null;
          this.talentpooldetails = sharedTalentPoolData ? (sharedTalentPoolData.talentpools || []).find((tp: any) => tp.talentpoolid == this.talentpoolid) : null;
          if(!this.talentpooldetails) {
            this.getTalentpoolList();
            return;
          }
        }
        this.talentpoolnumber = this.talentpooldetails.talentpoolnumber
        this.getCandidateList()
    } else {
      this.getCandidateList()
    }
    
    if (this.router.url) {
      if (this.router.url.includes('talentpool')) {
        this.enrichedFromForReveal = 'talentpool';
      }
      else if (this.router.url.includes('candidate-list')) {
        this.enrichedFromForReveal = 'all-candidates'
      }
    }
    let candidateid = this.route.snapshot.queryParamMap.get('candidateid');
    // if(candidateid){
    //   window.history.replaceState( {} , '', window.location.origin + window.location.pathname );
    //   setTimeout(()=>{
    //     this.OpenCandidateSlider(candidateid, 'details')
    //   },500)
    // }

    // this.candidateservice.getduplicatecandidateid().subscribe(candidateid => {
    //   this.OpenCandidateSlider(candidateid, 'details')
    // })
    this.userEmailId = this._localstorageservice.getItem('usermailid');
    this.bulkRevealBannerStatus();
  }

  /**
   * Computed property to get bulk-selected candidates after exclusions (for bulk selection across entire listing)
   */
  private get totalBulkCandidateNumbersAfterExclusions() {
    const excludedCandidatesSet = new Set(this.excludedCandidatesAfterBulkSelect);
    return this.totalBulkCandidatesNumber.filter(cand => !excludedCandidatesSet.has(cand));
  }

  toastmessage(message, type) {
    if (type == 'success') {
      this.successMessage = message;
      setTimeout(() => this.successMessage = '', 5000);
    } else if (type == 'error')
      this.errorMessage = message;
    setTimeout(() => this.errorMessage = '', 5000);
  }


  pagination(type) {
    if (type == 'next') {
      this.start = this.start + 10
      this.end = this.start + 10
      if (this.end > this.total)
        this.end = this.total
      // this.getTalentpoolList();
      this.removeSubject.next({ getFilter: true});
    } else if (type == 'prev') {
      this.start = this.start - 10
      this.end = this.start + 10
      // this.getTalentpoolList();
      this.removeSubject.next({ getFilter: true});
    }
  }
 
  sortCandidateList(type, value) {
    if (type == 'recent') {
      this.sortBy = 'new'
      this.recent = true
      this.oldest = false
      // this.getTalentpoolList();
      this.removeSubject.next({ getFilter: true});
    } else if (type == 'oldest') {
      this.sortBy = 'old'
      this.recent = false
      this.oldest = true
      // this.getTalentpoolList();
      this.removeSubject.next({ getFilter: true});
    }

    //if SortBy is Untick , Default
    if (value == false) {
      this.sortBy = 'new'
      this.removeSubject.next({ getFilter: true});
      // this.getTalentpoolList();
    }

  }

  getTalentpoolList() {
    this.talentpoolservice.getTalentpoolList(this._localstorageservice.getItem('usernumber')).subscribe(async (res: any) => {
      if (res.status == "success") {
        this._localstorageservice.setItem('talentPoolDetails', JSON.stringify(res?.data) || null);
        this.talentpoolservice.setTalentPoolDetails(res?.data || null);
        this.talentpoolslist = res.data.talentpools
        this.talentpoolid = this.router.url.split('/')[3]
        const currentTalentpoolDetails = res.data.talentpools.filter((x) => { return x.talentpoolid == this.talentpoolid })[0];
        if(currentTalentpoolDetails) {
          this.talentpooldetails = currentTalentpoolDetails;
        } else {
          this.isSharedTalentpool = true;
          const resp = await this.talentpoolservice.getSharedTalentpoolsList(this._localstorageservice.getItem('usernumber')).toPromise();
          if(resp && resp.status === 'success') {
            this.talentpooldetails = (resp?.data?.talentpools || []).find((tp: any) => tp.talentpoolid == this.talentpoolid);
          }
        }
        this.talentpoolnumber = this.talentpooldetails.talentpoolnumber
        this.getCandidateList()
      }
    });
    

  }


  ChangeTalentStatus(type) {
    this.removeSubject.next({ removeFilter: true});
    if (type == 'all') {
      this.talent_option = 'all'
    } else {
      this.talent_option = type
    }
    this.start = 0
    this.appliedFilters = []
    this.selectAll(false)
   // this.getTalentpoolList(); 
  }

  getCandidateList(val = null, source?: string) {
    if (!source || (source && source != 'fromSlider')) {
      this.showLoaderOnCandidateList = true;
    }

    if((this.appliedFilters && this.appliedFilters && Object.keys(this.appliedFilters).length) < (val && val.payload && Object.keys(val.payload).length)){
      this.start = 0;
    }
   // this.appliedFilters = val ? val.payload : '';
    if(val && val.isReset == true){
      this.start = 0
    }
    let data = {
      startingfrom: this.start,
      usernumber: this._localstorageservice.getItem('usernumber'),
      ...this.appliedFilters,
      sortby: this.sortBy || 'new' 
    }
   
    if (this.talent_option == 'all') {
      data['pipelinestatus'] = "'Hot', 'Warm', 'Cold'"
    } else {
      data['pipelinestatus'] = "'" + this.talent_option + "'"
    }

    if(this.talentpooldetails && this.talentpooldetails.talentpoolnumber){
      data['talentpoolnumber'] = this.talentpooldetails.talentpoolnumber
    }
    if(this.sortby) {
      data['sortby'] = this.sortby
    }
    this.candidateservice.getCandidateList(data).subscribe((res: any) => {
      if (res.status == "success") {
        this.excludedCandidatesAfterBulkSelect = [];
        this.totalcandidatecount = res.data.candidatedetails.length;
        this.showLoaderOnCandidateList = false;
        this.bulkRevealPayloadTalentpoolLevel(res?.data?.candidatesWitoutContactDetail);

        this._localstorageservice.setItem('talentPoolDetails', res.data);
        // this.candidateTotalCount = res.data.allcandidatescount
        this.candidateTotalCount = res.data.candidatenumbers.length
        this.talentpoolservice.setAllCandidateDetails(res?.data || null);
        this.talenpoolrefreshEvent.emit('refresh')
        this.candidateEvent.emit(this.candidateTotalCount)
        this.totalBulkCandidatesNumber = res.data.candidatenumbers
       // this.talentpipelinestates = res.data.totalcountindifferentpipelinestatus
        this.candidatedetails = res.data.candidatedetails
        this.candidatelist = res.data.candidatedetails.map(x => x.basicdetails)
        // this.coldtalent = this.talentpipelinestates.filter((x: any) => { return x.pipelinestatus == 'Cold' })
        // this.warmtalent = this.talentpipelinestates.filter((x: any) => { return x.pipelinestatus == 'Warm' })
        // this.hottalent = this.talentpipelinestates.filter((x: any) => { return x.pipelinestatus == 'Hot' })
        this.candidatedetails.map(res=>{
          let companyWebsiteDetails = res.experienceDetails.find(x => x.companyname === res.basicdetails.companyname)
          if(companyWebsiteDetails && companyWebsiteDetails.website){
            res.basicdetails.website = res.experienceDetails.find(x => x.companyname === res.basicdetails.companyname).website
          }
          res.currentexprience = res.experienceDetails && res.experienceDetails.filter(x=>x.iscurrent == 1)
          res.currentexprience = _.sortBy(res.currentexprience, 'startdate').reverse()
          if(res.currentexprience.length > 0) {
            const startDate = res.currentexprience[0].startdate ? moment(res.currentexprience[0].startdate) : null;
            const endDate = moment(res.currentexprience[0].enddate || new Date());
            const totalTenure = endDate.diff(startDate, 'years', true);
            res.currenttenure = this.getFormattedTenure(totalTenure);
          }
          res.pastexperience = res.experienceDetails.filter(obj => obj.iscurrent != 1);
          res.pastexperience.map(x=>{
            const startDate = x.startdate ? moment(x.startdate) : null;
            const endDate = moment(x.enddate || new Date());
            const totalTenure = endDate.diff(startDate, 'years', true);
            x.totaltenure = this.getFormattedTenure(totalTenure);    
            return x;
          })
          if(res.contactdetails.socialprofiles) {
            if(res.contactdetails.socialprofiles.existingDetails.length > 0) {
              res.linkedin_url = res.contactdetails.socialprofiles.existingDetails.filter(x=>x.platformname == 'linkedin')[0]
              res.facebook_url = res.contactdetails.socialprofiles.existingDetails.filter(x=>x.platformname == 'facebook')[0]
              res.twitter_url = res.contactdetails.socialprofiles.existingDetails.filter(x=>x.platformname == 'twitter')[0]
              res.github_url = res.contactdetails.socialprofiles.existingDetails.filter(x=>x.platformname == 'github')[0]
            }
            if(res.contactdetails.socialprofiles.moreAvailableDetails.length > 0) {
              res.linkedin_url = res.linkedin_url ? res.linkedin_url: res.contactdetails.socialprofiles.moreAvailableDetails.filter(x=>x.platformname == 'linkedin')[0]
              res.facebook_url = res.facebook_url ? res.facebook_url: res.contactdetails.socialprofiles.moreAvailableDetails.filter(x=>x.platformname == 'facebook')[0]
              res.twitter_url = res.twitter_url ? res.twitter_url: res.contactdetails.socialprofiles.moreAvailableDetails.filter(x=>x.platformname == 'twitter')[0]
              res.github_url = res.github_url? res.github_url: res.contactdetails.socialprofiles.moreAvailableDetails.filter(x=>x.platformname == 'github')[0]

            }
          }
          if(res.lastcandidateactivity.length > 0) {
            res.lastactivity = this.getActivityText(res.lastcandidateactivity[0])
          }
          res.personal_email = []
          res.work_email = []
          res.mobile_phone =[]

          
            
              if(res.contactdetails){
                if(res.contactdetails.emails && res.contactdetails.emails.existingDetails || res.contactdetails.contactnumbers && res.contactdetails.contactnumbers.existingDetails){
                  if((res.contactdetails.emails && res.contactdetails.emails.existingDetails.length > 0) || (res.contactdetails.contactnumbers && res.contactdetails.contactnumbers.existingDetails.length > 0)){
                    let professionalCount
                    let personalCount

                    if(res.contactdetails.emails && res.contactdetails.emails.existingDetails && res.contactdetails.emails.existingDetails.length){
                      let conedEmail =__.cloneDeep(res.contactdetails.emails)
                      professionalCount = conedEmail.existingDetails.filter(x => x.contactdetailcategory == 'professional')
                      personalCount = conedEmail.existingDetails.filter(x => x.contactdetailcategory == 'personal')

                    }

                    let phoneCount;
                    if(res.contactdetails.contactnumbers && res.contactdetails.contactnumbers.existingDetails && res.contactdetails.contactnumbers.existingDetails.length){
                      let conedContact =__.cloneDeep(res.contactdetails.contactnumbers)

                      phoneCount = conedContact.existingDetails.filter(x => x.type == 'contactnumber')
                    }
                    

                    if(professionalCount && professionalCount.length && personalCount && personalCount.length && phoneCount && phoneCount.length){
                      res.canShowLookingMore = false
                    }else{
                      res.canShowLookingMore = true
                    }
                  }
                }
              }
            
          

          if(res.contactdetails.emails) {
            if(res.contactdetails.emails.existingDetails.length > 0) {
              res.personal_email = res.contactdetails.emails.existingDetails.filter(x=>x.contactdetailcategory == "personal" )
              res.work_email = res.contactdetails.emails.existingDetails.filter(x=>(x.contactdetailcategory == 'work' || x.contactdetailcategory == 'professional' || x.contactdetailcategory == 'current_professional'))
            }
          } else {
            res.personal_email = undefined;
            res.work_email = undefined;
          }
          if(res.contactdetails.contactnumbers) {
            if(res.contactdetails.contactnumbers.existingDetails.length > 0) {
              res.mobile_phone = res.contactdetails.contactnumbers.existingDetails.filter(x=>x.type == 'contactnumber' )
            }
          } else {
            res.mobile_phone = undefined;
          }
          if((!res.contactdetails.emails || (res.contactdetails.emails && res.contactdetails.emails.existingDetails.length == 0))) {
            res.hasemailreveal = true
          } else {
            res.hasemailreveal = false
          }

          if(!res.contactdetails.contactnumbers || (res.contactdetails.contactnumbers && res.contactdetails.contactnumbers.existingDetails.length == 0)) {
            res.hascontactreveal = true
          } else {
            res.hascontactreveal = false
          }

          // if((!res.contactdetails.emails) || (!res.contactdetails.contact)) {
          //   res.hasnorevealinfo = true
          // } else {
          //   res.hasnorevealinfo = false
          // }

          return res;
        })

        // if(this.candidatedetails['pastexperience'] && this.candidatedetails['pastexperience'].length > 0) {
        //   this.candidatedetails['pastexperience'].map(res=>{
        //     const startDate = res.startdate ? moment(res.startdate) : null;
        //     const endDate = moment(res.enddate || new Date());
        //     const totalTenure = endDate.diff(startDate, 'years', true);
        //     res.totaltenure = this.getFormattedTenure(totalTenure);    
        //     return res;      
        //   })
        // }
        
        this.candidatedetails.map(x => {
          return x.basicdetails['updatedon'] = GlobalService.getDates(x.basicdetails['updatedon']).text;
        })

        if (this.talent_option == 'all') {
          this.talent_count = this.candidateTotalCount
        } else if (this.talent_option == 'Hot') {
          this.talent_count = this.hottalent[0].count
        }
        else if (this.talent_option == 'Warm') {
          this.talent_count = this.warmtalent[0].count
        }
        else if (this.talent_option == 'Cold') {
          this.talent_count = this.coldtalent[0].count
        }

        this.total = this.talent_count
        if (this.start == 0) {
          if (this.end > this.total) {
            this.end = this.total
          }
          if (this.total == 0) {
            this.start = this.total;
            this.end = this.total
          } else if (this.total < 10) {
            this.end = this.total
          } else {
            this.end = this.start + 10;
          }
        }

        if (this.talent_option == 'all') {
          this.talent_count = this.candidateTotalCount
        }
      }
    })

  }

  /**
   * Create a payload for bulk reveal,
   * candidates will be selected from completee talentpool, whose contact details are not present.
   * @param candidatesWitoutContactDetail array of candidates having no contact details
   */
  bulkRevealPayloadTalentpoolLevel(candidatesWitoutContactDetail) {
    const bulkRevealPayLoad = {
      enrichedFrom: this.enrichedFromForReveal,
      talentpoolnumber: this.talentpoolnumber,
      candidates: []
    }
    if(candidatesWitoutContactDetail){
      if (candidatesWitoutContactDetail && candidatesWitoutContactDetail.length) {
        candidatesWitoutContactDetail.map(x => {
          if (!x?.bulkcontactrevealstatus && x.elastic_id) {
            bulkRevealPayLoad.candidates.push({
              elastic_id: x.elastic_id,
              talentpoolcandidatemappingid: x?.talentpoolcandidatemappingid
            })
          }
        })
      }
    }

    this.bulkRevealBannerTalentpoolLevel = {
      showBanner: (bulkRevealPayLoad.candidates.length > 1) ? true : false,
      candidateCount: bulkRevealPayLoad.candidates.length,
      user: this.firstNameUser,
      bulkRevealPayLoad: bulkRevealPayLoad
    }
  }

  /**
   * Open Bulk Reveal modal, When find contacts from banner
   * @param bulkRevealPayLoad Payload for bulk reveal
   */
  openBulkRevealModal(bulkRevealPayLoad) {
    const modalObj = {
      calledFor:'talentpool',
      total_target: bulkRevealPayLoad.candidates.length,
      emailsFound: 0,
      payload: bulkRevealPayLoad,
      campaign_id: null,
      onTalentpoolLevel: true
    }
    this.openDetailsModal(modalObj);
  }

  setPage(index: number) {
    this.resetAllSelections();
    this.selectedcandidate = [];
    this.selected = false;

    let start = (index - 1) * this.pageSize
    this.start = start
    this.end = this.start + this.pageSize
    if (this.end > this.candidateTotalCount) {
      this.end = this.candidateTotalCount
    }
    this.getCandidateList();
    this.document.documentElement.scrollTop = 0;
    this.bulkRevealBannerStatus();
  }
  getTalentpoolCandidate(talentpoolnumber) {
    let data = {
      talentpoolnumber: talentpoolnumber,
      startingfrom: this.start,
      usernumber: this._localstorageservice.getItem('usernumber')
    }
    if (this.talent_option == 'all') {
      data['pipelinestatus'] = "'Hot', 'Warm', 'Cold'"
    } else {
      data['pipelinestatus'] = "'" + this.talent_option + "'"
    }
    this.candidateservice.getCandidateList(data).subscribe((res: any) => {
      if (res.status == "success") {
        this._localstorageservice.setItem('talentPoolDetails', res.data);
        this.totalcandidatecount = res.data.candidatedetails.length;
        this.candidateTotalCount = res.data.totalcandidatesintalentpool
        this.totalBulkCandidatesNumber = res.data.candidatenumbers
       // this.talentpipelinestates = res.data.totalcountindifferentpipelinestatus
        this.candidatedetails = res.data.candidatedetails
        this.candidatelist = res.data.candidatedetails.map(x => x.basicdetails)
        // this.coldtalent = this.talentpipelinestates.filter((x: any) => { return x.pipelinestatus == 'Cold' })
        // this.warmtalent = this.talentpipelinestates.filter((x: any) => { return x.pipelinestatus == 'Warm' })
        // this.hottalent = this.talentpipelinestates.filter((x: any) => { return x.pipelinestatus == 'Hot' })
        this.candidatedetails.map(x => {
          return x.basicdetails['updatedon'] = GlobalService.getDates(x.basicdetails['updatedon']).text;
        })
      }
      if (this.talent_option == 'all') {
        this.talent_count = this.candidateTotalCount
      } else if (this.talent_option == 'Hot') {
        this.talent_count = this.hottalent[0].count
      }
      else if (this.talent_option == 'Warm') {
        this.talent_count = this.warmtalent[0].count
      }
      else if (this.talent_option == 'Cold') {
        this.talent_count = this.coldtalent[0].count
      }

      this.total = this.talent_count
      if (this.start == 0) {
        if (this.end > this.total) {
          this.end = this.total
        }
        if (this.total == 0) {
          this.start = this.total;
          this.end = this.total
        } else if (this.total < 10) {
          this.end = this.total
        } else {
          this.end = this.start + 10;
        }
      }
    })
  }

  /**
   * select one candidate
   * @param candidate 
   * @param value 
   */
  checkIfAllSelected(candidate, event) {
    let value = event.target.checked
    if (value == true) {
      this.isCandidateSelected = true;
      this.selectedcandidate.push(candidate.basicdetails.candidatenumber)
      if(this.selectedcandidate.length == this.totalcandidatecount) {
        this.selected = true
      }
    } else {
      if(this.isBulkSelect) {
        this.excludedCandidatesAfterBulkSelect.push(candidate?.basicdetails?.candidatenumber);
      }
      this.selectedcandidate = _.without(this.selectedcandidate, candidate.basicdetails.candidatenumber);
      this.selected = false
    }
    /**To calculate the number of profiles with personal email or contact number */
    this.bulkRevealPayload();
  }

  /**
   * select all candidates
   * @param event 
   */
  selectAll(event) {
    const value = event.target && event.target.checked ? true : false;
    if (value == true) {
      this.isBulkSelect = true;
      this.isCandidateSelected = true;
      this.selectedcandidate = []
      this.selectedcandidateForNote = []
      this.candidatedetails.forEach((element, index) => {
        this.candidatedetails[index].selected = true;
        this.selectedcandidate.push(element.basicdetails.candidatenumber)
        this.selectedcandidateForNote.push({candidatenumber : element.basicdetails.candidatenumber,basicdetails : element.basicdetails})
      })
    } else if (value == false) {
      this.isCandidateSelected = false;
      this.candidatedetails.forEach((element, index) => {
        this.candidatedetails[index].selected = false;
        this.selectedcandidate = []
        this.selectedcandidateForNote = []
      })
      this.isBulkSelect = false;
      this.selected = false;
      this.excludedCandidatesAfterBulkSelect = [];
    }
     /**To calculate the number of profiles with personal email or contact number */
     this.bulkRevealPayload();
  }

  /**
   * Reset all selections in the current listing
   */
  resetAllSelections() {
    this.selected = false;
    this.isBulkSelect = false;
    this.excludedCandidatesAfterBulkSelect = [];
    this.selectedcandidate = [];
    this.candidatedetails.forEach(cand => cand.selected = false);
  }

  //Bulk Candidate Select All from Database
  getAllActiveCandidates() {
    this.selectedcandidate = this.totalBulkCandidatesNumber
    this.isBulkSelect = true

  }


  //Confirmation Modal to Remove Candiate from TAlentpool
  RemoveBulkCandidatesFromTalentpoolModal() {
    const confirmRef = this.modalService.open(this.removeCandidatefromTalentpool, { size: 'xs' as 'lg', centered: true, backdrop: 'static', keyboard: false });

  }

  /**
   * remove selected candidate/candidates from talentpool
   */

  removecandidatefromtalentpool() {
    if(this.talentpoolid) {
      let candidateobject = [];
      for (let candidate of this.selectedcandidate) {
        candidateobject.push({
          candidatenumber: candidate,
        })
      }
      let data = {
        talentpoolnumber: this.talentpooldetails.talentpoolnumber,
        candidateidList: candidateobject,
        usernumber: this._localstorageservice.getItem('usernumber')
      }
  
  
      this.talentpoolservice.removeCandidatefromTalentpool(data).subscribe((res: any) => {
        if (res.status == 'success') {
          this.modalService.dismissAll();
          this.talenpoolrefreshEvent.emit('refresh')
          this.talenttabsrefreshEvent.emit('refresh')
          this.toastmessage("Selected Candidates Removed from Talentpool Succesfully", "success")
          this.getCandidateList();
          this.selectAll(false)
        }
        else {
          this.modalService.dismissAll();
          this.toastmessage("Something went Wrong", "error")
        }
      })
    } else {
      let data = {
        candidatenumber: this.selectedcandidate.length > 1 ? this.selectedcandidate: this.selectedcandidate[0]
      }
      this.candidateservice.deleteAllCandidates(data).subscribe((res:any)=>{
        if (res.status == 'success') {
          this.modalService.dismissAll();
          this.toastmessage("Candidates archived successfully", "success")
          this.talenpoolrefreshEvent.emit('refresh')
          this.talenttabsrefreshEvent.emit('refresh')
          this.getCandidateList();
          this.selectAll(false)
        }
        else {
          this.modalService.dismissAll();
          this.toastmessage("Something went Wrong", "error")
        }
      })
    }

  }


  openAddTalentpoolModal(candidate) {
    const modalRef = this.modalService.open(AddToTalentpoolComponent, { size: 'lg' as 'lg', centered: true });
    modalRef.componentInstance.candidatetoAdd = candidate ? candidate.basicdetails: []
    modalRef.componentInstance.BuldCandidatetoAdd = this.selectedcandidate
    modalRef.componentInstance.type = 'candidate'
    modalRef.componentInstance.passEntry.subscribe((x) => {
      if (x == 'candidateAdded') {
        this.toastmessage('Candidate Added to Talentpool Succesfully', 'success')
      //  this.getTalentpoolList()
        this.selectAll(false)
      } else if (x == 'alreadyexist') {
        this.toastmessage('Candidate has already been added to this talentpool', 'error')
      }else if (x == 'Missing parameters') {
        this.toastmessage('Unable to add profile to the talent pool. Please try again.', 'error')
      }else if (x == 'error') {
        this.toastmessage('Something went Wrong', 'error')
      }
      this.candidatedetails = this.candidatedetails.map(c => ({...c, selected: false}));
    })
  }

  OpenCandidateSlider(candidate, type) {
    document.getElementById("mySidebar2").style.display = "block";
    document.getElementById("myOverlay2").style.display = "block";
    this.parentSubject.next({ candidatenumber: candidate.candidatenumber, tabtoShow: type, elasticid: candidate.elastic_id, candidateId: this.candidatedetails.filter(x=>x.basicdetails.candidatenumber==candidate.candidatenumber) && this.candidatedetails.filter(x=>x.basicdetails.candidatenumber==candidate.candidatenumber).length ? this.candidatedetails.filter(x=>x.basicdetails.candidatenumber==candidate.candidatenumber)[0].candidateid: null });
  }

  opensliderforContacts(candidate, type) {
    document.getElementById("mySidebar2").style.display = "block";
    document.getElementById("myOverlay2").style.display = "block";
    this.parentSubject.next({ candidatenumber: candidate.candidatenumber, tabtoShow: type, elasticid: candidate.elastic_id  });
    // const loadn = document.querySelectorAll<HTMLElement>('.loading-screen-wrapper');
    // loadn[0].style.display = 'none'
  }


  OpenCandidateList(type) {
    if (type == 'all') {
      this.router.navigateByUrl("/candidate-list")
    }
    else {
      let talentpoolid = type.talentpoolid
      this.router.navigateByUrl('/', { skipLocationChange: true }).then(() =>
        this.router.navigate(['candidate-list/talentpool/' + talentpoolid]));
      this.talentpoolview = true;
    }
  }


  openAddNOtesModal(candidate) {
    const modalRef = this.modalService.open(CandidateNoteComponent, { size: 'xs' as 'lg', centered: true });
    modalRef.componentInstance.noteforCandidate = candidate ? candidate.basicdetails  : null
    modalRef.componentInstance.BuldnoteforCandidate = this.selectedcandidateForNote
    modalRef.componentInstance.passEntry.subscribe((x) => {
      if (x == 'noteAdded') {
        this.toastmessage('Notes Added for Selected Candidate Succesfully', 'success')
        this.getCandidateList()
        this.selectAll(false)

      } else if (x == 'error') {
        this.toastmessage('Something went Wrong, Please try again in a minute', 'error')
      }
    })
  }

  openCallLogModal(candidate) {
    const modalRef = this.modalService.open(CallLogComponent, { size: 'xs' as 'lg', centered: true });
    modalRef.componentInstance.calllogforCandidate = candidate ? candidate : null
    modalRef.componentInstance.BulkcalllogforCandidate = this.selectedcandidate
    modalRef.componentInstance.passEntry.subscribe((x) => {
      if (x == 'calllogAdded') {
        this.toastmessage('Call Logs Added for Candidate Succesfully', 'success')
        this.selectAll(false)
      } else if (x == 'error') {
        this.toastmessage('Something went Wrong', 'error')
      }
    })
  }


  openSendBulkEmailModal(candidate) {
    if(this._localstorageservice.getItem('secredits') >= this.selectedcandidate.length){
    if (candidate || this.selectedcandidate.length <= 10) {
      const modalRef = this.modalService.open(CandidateEmailComponent, { size: 'lg' as 'lg', centered: true });
      modalRef.componentInstance.emailforCandidate = candidate ? candidate : null
      let selectedemailcandidates = []
      if(this.selectedcandidate.length > 0){
        this.selectedcandidate.forEach((element, index) => {
          selectedemailcandidates.push(this.candidatedetails.filter((x)=> {return x.basicdetails.candidatenumber == element }))
        })
      }
      modalRef.componentInstance.BulkCandidateEmail = selectedemailcandidates
      modalRef.componentInstance.passEntry.subscribe((x) => {
        if (x == 'emailsend') {
          this.toastmessage('Email Send Successfully', 'success')
          this.selectAll(false)
          setTimeout(()=>{
            this.fetchcredits()
          },1000)
         
        } else if (x == 'error') {
          this.toastmessage('Something went Wrong', 'error')
        } else if (x == 'limitexceeded') {
          this.toastmessage('mail limit exceeded', 'error')
        } else if (x == 'nocredits') {
          this.modalService.open(this.noCreditsSE,{ windowClass: "myCustomModalClass", centered: true });
          this.sendmailexpiry('Smart Email credits')
        } else if(x == 'noEmail'){
          this.modalService.open(this.noEmailModal, { size: 'md' as 'lg', centered: true, backdrop: 'static', keyboard: false });
        }

      })
    } else {
      this.modalService.open(this.bulkemailerlimit, { size: 'md' as 'lg', centered: true, backdrop: 'static', keyboard: false })
    }
    }else{
      this.sendmailexpiry('Smart Email credits')
      this.modalService.open(this.noCreditsSE,{ windowClass: "myCustomModalClass", centered: true });
    }
  }

  DeleteTalentpoolConfirmation() {
    const confirmRef = this.modalService.open(this.deleteTalentpool, { size: 'xs' as 'lg', centered: true, backdrop: 'static', keyboard: false });
  }

  DeleteTalentpool() {
    let data = {
      talentpoolnumber: this.talentpooldetails.talentpoolnumber,
      usernumber: this._localstorageservice.getItem('usernumber')
    }

    this.talentpoolservice.RemoveTalentpoolDetails(data).subscribe((res: any) => {
      if (res.status == 'success') {
        this.successMessage = "Talentpool Deleted Successfully"
        this.modalService.open(this.successModal, { size: 'xs' as 'lg', centered: true, backdrop: 'static', keyboard: false });
        this.router.navigate(['candidate-list'])
        this.fetchcredits()
      }
      else {
        this.errorMessage = "Something Went Wrong"
        this.modalService.open(this.errorModal, { size: 'xs' as 'lg', centered: true, backdrop: 'static', keyboard: false });
      }
    })
  }

  EditTalentpoolDetails() {
    const modalRef = this.modalService.open(CreateTalentpoolComponent, { size: 'lg' as 'lg', centered: true });
    modalRef.componentInstance.TalentpoolIDtoEdit = this.talentpooldetails.talentpoolnumber
    modalRef.componentInstance.passEntry.subscribe((x) => {
      if (x == 'talentpool-edited') {
        this.toastmessage("Talentpool Edited Successfully", 'success')
      }
    })
  }

  /**
   * Trigger confirmation modal for bulk-download candidates CSV
   */
  triggerBulkDownloadCandidatesCSVModal() {
    this.modalService.open(this.bulkDownloadAsCSVModal, { size: 'md' as 'lg', centered: true, backdrop: 'static', keyboard: false });
  }

  /**
   * Bulk download candidates to CSV via service call & generating CSV file
   */
  async DownloadCandidateCSV(){
    if(this.plandetails !='Free'){
      this.processingCSVDownload = true;
      const candidatesToDownloadAsCSV = this.bulkDownloadCSVSelectedOption == 'All' ? this.totalBulkCandidateNumbersAfterExclusions : this.selectedcandidate;

      const data = {
        candidatenumbersarray: candidatesToDownloadAsCSV,
        usernumber:this._localstorageservice.getItem('usernumber')
      }
    this.candidateservice.fetchcandidatedetailsforcsvdownload(data).subscribe(async (res:any)=>{
      if(res.status == 'failure' && res.message =='free plan user'){
        this.modalService.open(this.upgradePlan,{ windowClass: "myCustomModalClass", centered: true });
      }else{
    let canddiatedata = res.data.filter((x: any) => x.firstname && x.lastname);

    let downloadobj = [];
    let headers = `First Name,Last Name,Source,Created by,Talent Pipeline,Social Profile URL,Primary Email ID,Primary Contact Number,All Social Profile URLs,All Emails,All Contact Numbers,Job Title,Company Name,Work Location,Experience Start Date,Experience End Date,Past Job Titles,Skills,Name of School,Degree,Start Year,End Year,Notes,Tags`;
    let filename = "Webbtree_candidates"

    canddiatedata.forEach(data => {
      let candidatelistobj = {};
      let headersmain = headers.split(",");

      headersmain.forEach((headers) => {
        let headersbe = headers
          .split(" ")
          .join("")
          .toLowerCase();

        if (headersbe == "firstname") {
          if (data["firstname"] != null) {
            candidatelistobj[headers] = GlobalService.titleCase(data["firstname"]);
          } else {
            candidatelistobj[headers] = 'N/A';
          }
        } else if (headersbe == "lastname") {
          if (data["lastname"] != null) {
            candidatelistobj[headers] = GlobalService.titleCase(data["lastname"]);
          } else {
            candidatelistobj[headers] = 'N/A';
          }
        } else if (headersbe == "source") {
          if (data["source"] != null) {
            candidatelistobj[headers] = GlobalService.titleCase(data["source"].replace(/[\[\]']+/g,''));
          } else {
            candidatelistobj[headers] = 'N/A';
          }
        } else if (headersbe == "createdby") {
          if (data["createdby"] != null) {
            candidatelistobj[headers] = GlobalService.titleCase(data["createdby"]);
          } else {
            candidatelistobj[headers] = 'N/A';
          }
        } else if (headersbe == 'talentpipeline') {
          if (data['talentpoolsarray'].length != 0) {
            candidatelistobj[headers] = data["talentpoolsarray"].join(', ');
          } else {
            candidatelistobj[headers] = 'N/A';
          }
        }
        else if (headersbe == 'socialprofileurl') {
          if (data['profileurl'] != null) {
            candidatelistobj[headers] = data["profileurl"];
          } else {
            candidatelistobj[headers] = 'N/A';
          }
        }
        else if (headersbe == 'primaryemailid') {
          if (data['primaryemailid']) {
            candidatelistobj[headers] = data["primaryemailid"];
          } else {
            candidatelistobj[headers] = 'N/A';
          }
        }
        else if (headersbe == 'primarycontactnumber') {
          if (data['primarycontactnumber']) {
            candidatelistobj[headers] = data["primarycontactnumber"];
          } else {
            candidatelistobj[headers] = 'N/A';
          }
        } else if (headersbe == 'allsocialprofileurls') {
          if (data['allsocialprofilesarray'].length != 0) { 
            candidatelistobj[headers] = data["allsocialprofilesarray"].join(', ');
          } else {
            candidatelistobj[headers] = 'N/A';
          }
        } else if (headersbe == 'allemails') {
          if (data['allemailsarray'].length != 0) {
            candidatelistobj[headers] = data["allemailsarray"].join(', ');
          } else {
            candidatelistobj[headers] = 'N/A';
          }
        } else if (headersbe == 'allcontactnumbers') {
          if (data['allcontactnumbersarray'].length != 0) {
            candidatelistobj[headers] = data["allcontactnumbersarray"].join(', ');
          } else {
            candidatelistobj[headers] = 'N/A';
          }
        } else if (headersbe == 'jobtitle') {
          if (data['jobtitle']) {
            candidatelistobj[headers] = GlobalService.titleCase(data["jobtitle"]);
          } else {
            candidatelistobj[headers] = 'N/A';
          }
        } else if (headersbe == 'companyname') {
          if (data['companyname']) {
            candidatelistobj[headers] = GlobalService.titleCase(data["companyname"]);
          } else {
            candidatelistobj[headers] = 'N/A';
          }
        } else if (headersbe == 'worklocation') {
          if (data['locationname']) {
            candidatelistobj[headers] = GlobalService.titleCase(data["locationname"]);
          } else {
            candidatelistobj[headers] = 'N/A';
          }
        } else if (headersbe == 'experiencestartdate') {
          if (data['experiencestartdate'] != null) {
            candidatelistobj[headers] = moment(data["experiencestartdate"]).format('YYYY-MM');
          } else {
            candidatelistobj[headers] = 'N/A';
          }
        } else if (headersbe == 'experienceenddate') {
          if (data['experienceenddate'] != null) {
            candidatelistobj[headers] = moment(data["experienceenddate"]).format('YYYY-MM');
          } else {
            candidatelistobj[headers] = 'Present';
          }
        } else if(headersbe == 'pastjobtitles') {
          if (data['allPastJobTitles'].length) {
            candidatelistobj[headers] = GlobalService.titleCase(data["allPastJobTitles"].join(', '));
          } else {
            candidatelistobj[headers] = 'N/A';
          }
        } else if (headersbe == 'skills') {
          if (data['allskillsarray'].length) {
            candidatelistobj[headers] = GlobalService.titleCase(data["allskillsarray"].join(', '));
          } else {
            candidatelistobj[headers] = 'N/A';
          }
        } else if (headersbe == 'nameofschool') {
          if (data['educationdetails'] && data['educationdetails'].institutename != null) {
            candidatelistobj[headers] = GlobalService.titleCase(data['educationdetails'].institutename)
          } else {
            candidatelistobj[headers] = 'N/A';
          }
        } else if (headersbe == 'degree') {
          if (data['educationdetails'] && data['educationdetails'].degree != null) {
            candidatelistobj[headers] = GlobalService.titleCase(data['educationdetails'].degree)
          } else {
            candidatelistobj[headers] = 'N/A';
          }
        }else if (headersbe == 'startyear') {
          if (data['educationdetails'] && data['educationdetails'].startdate != null) {
            candidatelistobj[headers] = moment(data['educationdetails'].startdate).format('YYYY-MM');
          } else {
            candidatelistobj[headers] = 'N/A';
          }
        } else if (headersbe == 'endyear') {
          if (data['educationdetails'] && data['educationdetails'].enddate != null) {
            candidatelistobj[headers] = moment(data['educationdetails'].enddate).format('YYYY-MM');
          } else {
            candidatelistobj[headers] = 'N/A';
          }
        }  else if (headersbe == 'notes') {
          if (data['allnotesarray'] && data['allnotesarray'].length > 0) {
            data['allnotesarray'] = data['allnotesarray'].map(x =>{
              let res = x
              res = "{" + x + "}"
              return res
            })
            candidatelistobj[headers] = data['allnotesarray'].toString()
          } else {
            candidatelistobj[headers] = 'N/A';
          }
        } else if (headersbe == 'tags') {
          if (data['alltagsarray'] && data['alltagsarray'].length > 0) {
            candidatelistobj[headers] = GlobalService.titleCase(data['alltagsarray'].join(', '));
          } else {
            candidatelistobj[headers] = 'N/A';
          }
        } 
        else {
          if (data[headersbe] != null) {
            candidatelistobj[headers] = data[headersbe];
          } else {
            candidatelistobj[headers] = 'N/A';
          }
        }
      });
      if (!_.isEmpty(candidatelistobj)) {
        downloadobj.push(candidatelistobj);
      }
    });

    let newobj = [];
    downloadobj.forEach(element => {
      newobj.push(Object.values(element));
    });

    try {
      
      // generate excel file
      filename = filename + (this.bulkDownloadCSVSelectedOption === 'All' ? '.xlsx' : '')
      const excelFile: Blob = await this.excel.exportAsExcelFile(
        newobj,
        filename,
        headers.split(","),
        null,
        this.bulkDownloadCSVSelectedOption == 'currentPage' // for current page, download on FE, else send over email
      );

      if(this.bulkDownloadCSVSelectedOption == 'All') {
        // convert excel file to base64 to be able to attach in email
        const base64FileData = await GlobalService.toBase64(excelFile)
        const emailPayload = {
          from: "Webbtree <notification@webbtree.com>",
          recipientEmails: [this._localstorageservice.getItem('userdata')?.loginemail],
          subject: "Webbtree Talent Discovery | Download Profiles as CSV",
          template: `Hi {{user.firstname}} {{user.lastname}},
                    <br/><br/>Please find attached the CSV file which has been downloaded for the selected profiles on the Webbtree Talent Discovery platform.
                    <br/><br/>Thanks and Regards,
                    <br />Team Webbtree`,
          attachments: [{ filename, path: base64FileData }],
          updatedby: this._localstorageservice.getItem('userdata')?.userid
        }  
        // send email
        const sendEmailResp: any = await this.emailsettings.sendbulkemail(emailPayload).toPromise();
        if (sendEmailResp && sendEmailResp.status == "success") {
          this.successMessage = "You will receive the CSV file on your email in a min.";
        } else {
          this.errorMessage = "Something went wrong";
        }
      }

    } catch (e) {
      console.log("DownloadCandidateCSV() error - ", e);
      this.errorMessage = "Something went wrong";
    }
  }
      setTimeout(() => {
        this.successMessage = "";
        this.successMessage = "";
      }, 5000);
      this.processingCSVDownload = false;
      // reset all selections in listing
      this.resetAllSelections();
      this.closeActiveModal();
  })
  }else{
    this.modalService.open(this.upgradePlan,{ windowClass: "myCustomModalClass", centered: true });
  }

  }

  route2pricing(){
    this.modalService.dismissAll()
    this.router.navigateByUrl('/subscription/pricing')
  }

  fetchcredits(){
    this.transactionservice.fetchcurrentplandetails(this._localstorageservice.getItem('usernumber')).subscribe((res:any)=>{
      if(res.status == 'success'){
        this.plandetails = res.data.plancost == 'free' ? 'Free' : 'Premium' 
        if (res.data.isteamadmin) {
          // Here the logged in person is a Team Admin
          this.subscriptiondetails.balancecontactenrichmentcredits = res.data.balancecontactenrichmentcredits;
          this.subscriptiondetails.balancejdparsingcredits = res.data.pooledbalancejdparsingcredits;
          this.subscriptiondetails.balancesmartemailcredits = res.data.pooledbalancesmartemailcredits;
          this.subscriptiondetails.balancetalentpipelinecredits = res.data.pooledbalancetalentpipelinecredits;
        } else {
          if (res.data.teamadmindetails) {
            // Here the logged in person is a Team Member
            this.isteamMember = true
            this.subscriptiondetails.balancecontactenrichmentcredits = res.data.balancecontactenrichmentcredits;
            this.subscriptiondetails.balancejdparsingcredits = res.data.teamadmindetails.adminbalancejdparsingcredits;
            this.subscriptiondetails.balancesmartemailcredits = res.data.teamadmindetails.adminbalancesmartemailcredits;
            this.subscriptiondetails.balancetalentpipelinecredits = res.data.teamadmindetails.adminbalancetalentpipelinecredits;
          } else {
            // Here the logged in person is a normal (who does not belong to any team)
            this.subscriptiondetails.balancecontactenrichmentcredits = res.data.balancecontactenrichmentcredits;
            this.subscriptiondetails.balancejdparsingcredits = res.data.balancejdparsingcredits;
            this.subscriptiondetails.balancesmartemailcredits = res.data.balancesmartemailcredits;
            this.subscriptiondetails.balancetalentpipelinecredits = res.data.balancetalentpipelinecredits;
          }
        }
        this._localstorageservice.setItem('jdcredits', this.subscriptiondetails.balancejdparsingcredits)
        this._localstorageservice.setItem('tpcredits', this.subscriptiondetails.balancetalentpipelinecredits)
        this._localstorageservice.setItem('cecredits', this.subscriptiondetails.balancecontactenrichmentcredits)
        this._localstorageservice.setItem('secredits', this.subscriptiondetails.balancesmartemailcredits)
      }
    })
  }

  sendmailexpiry(type){
    let data ={
      expiredmetric : type
    }
    this.transactionservice.sendcreditexpirymail(data).subscribe()
  }

  filterSlider_open(){ 
    document.getElementById("mySidebar_filter").style.display = "block";
    document.getElementById("myOverlay_filter").style.display = "block";
    if (this.talentpoolnumber) {
      this.removeSubject.next({ talentpoolnumber: this.talentpoolnumber });
    }
  }
  filterJobs(data) {
    this.appliedFilters = data ? data.payload : ''
     this.getCandidateList(data);
     this.appliedfiltercount = data.payload.filtercount
     this.talenpoolrefreshEvent.emit('refresh')
     this.talenttabsrefreshEvent.emit(this.appliedFilters)

  }

  transform(value: string | string[]): string {
    if (!value) {
      return '';
    }

    if (Array.isArray(value)) {
      value = value[0] || '';
    }

    const regex = /(<.*?>)?([^<>]+)/g;
    const transformedValue = value.replace(regex, (match, htmlTag, text) => {
      if (text) {
        const transformedText = text.toLowerCase().replace(/\b\w/g, char => char.toUpperCase());
        const result = htmlTag ? `${htmlTag}${transformedText}` : transformedText;
        // remove htmltag
        if (result.includes('<')) {
          return result.replace(/<.*?>/g, '');
        }

        return result;
      }
      return match;
    });

    return transformedValue;
  }

  isBoolean() {

  }
/**
 * get format for totalexperience
 * @param tenure 
 * @returns 
 */
  
  private getFormattedTenure(tenure: number) {
    const totalYears = Math.floor(tenure);
    const totalMonths = Math.round((tenure - totalYears) * 12);
    if (totalYears > 0 && totalMonths > 0) {
      return `${totalYears} ${totalYears == 1 ? 'Yr' : 'Yrs'} ${totalMonths} Mths`;
    } else if (totalYears > 0 && totalMonths == 0) {
      return `${totalYears} ${totalYears == 1 ? 'Yr' : 'Yrs'}`;
    } else if (totalYears == 0 && totalMonths > 0) {
      return `${totalMonths} Mths`;
    } else {
      return '';
    }
  }

  viewmoredetails(data, i, type) {
    if (type == 'viewmore') {
      document.getElementById('exp_less' + i).style.display = 'none'
      document.getElementById('exp_more' + i).style.display = 'block'
    } else {
      document.getElementById('exp_less' + i).style.display = 'block'
      document.getElementById('exp_more' + i).style.display = 'none'
    }
  }

  deleteCandidate(candidate?) {
      const confirmRef = this.modalService.open(this.removeCandidatefromTalentpool, { size: 'xs' as 'lg', centered: true, backdrop: 'static', keyboard: false });
      if(candidate)
        this.selectedcandidate.push(candidate.basicdetails.candidatenumber); 


  }

  sortcandidatelist(sortby) {
    this.sortby = sortby
    this.getCandidateList()
  }

  getActivityText(activity): string {
    let action;
    if (activity.oldvalue == "" || activity.oldvalue == "null") {
      activity.oldvalue = null
    }
    if (activity.newvalue === '' || activity.newvalue === null || activity.newvalue === '') {
      action = 'deleted';
    } else if (activity.oldvalue === '' || activity.oldvalue === null) {
      action = 'added';
    }
    if (activity.action === 'create' || activity.action === 'add') {
      action = 'created';
    } else if (activity.action === 'remove' || activity.action === 'delete') {
      action = 'deleted';
    } else if (activity.action === 'update' || activity.action === 'updated') {
      action = 'updated';
    } else {
      action = activity.action;
    }
    ///For call Log and Notes
    if (action === 'updated' && activity.type === 'calllog') {
     return "Calllog updated"
    }
    else if (action === 'created' && activity.type === 'calllog') {
      return "Calllog craeted"
    }
    else if (action === 'updated' && activity.type === 'note') {
      return `Note updated`;
    }
    else if (action === 'created' && activity.type === 'note') {
      return `Note Created`;
    } else if (action == 'deleted' && activity.type === 'note') {
      return `Note was removed`;
    }
    ///For Experience 
    else if (action === 'updated' && activity.type === 'experience' && activity.newvalue !== null) {
      return 'Experience updated'
    } else if (action === 'deleted' && activity.type === 'experience') {
      return `Experience has been removed`;
    }
    else if (action === 'created' && activity.type === 'experience') {
      return `Experience Added`;
    }
    //for Education
    else if (action === 'updated' && activity.type === 'education') {
     return `Education updated`
    }
    else if (action === 'deleted' && activity.type === 'education') {
      return `Education has been removed`;
    }
    else if (action === 'created' && activity.type === 'education') {
      return `Education Added`;
    }
    //for Basic Details
    else if (action == 'updated' && activity.type === 'basic details' && activity.oldvalue != null) {
      return `Profile details updated`;
    }
    else if (action == 'updated' && activity.type === 'basic details' && activity.oldvalue == null) {
      return `${activity.updatedfieldname} has been updated to ${activity.newvalue}`;
    }
    //for Skills
    else if (action == 'updated' && activity.type === 'skills') {
      return `Skills are updated`;
    } else if (action == 'created' && activity.type === 'skills') {
      return `Skills are Added`;
    }

    //for tags
    else if (action == 'updated' && activity.type === 'tags') {
      return `Tags are updated`;
    } else if (action == 'created' && activity.type === 'tags') {
      return `Tags are Added`;
    } else if (action == 'deleted' && activity.type === 'tags') {
      return `Tags are deleted`;
    }
    //for Grabbed
    else if (action == 'created' && (activity.type === 'grabbed' || activity.type == 'bulk grabbed')) {
      return `Candidate has been grabbed`;
    }
    else if (action == 'created' && activity.type === 'added') {
      return `Candidate has been Added`;
    }
    //for TalentPipeline Status
    else if (action == 'updated' && (activity.type === 'pipeline status' || activity.type === 'cron - pipeline status')) {
      return `Pipeline Status was updated`;
    }
    //for Contact Details
    else if (action == 'created' && activity.type === 'contact details - social profile') {
      return `New Social Profile Link was Added`;
    }
    else if (action == 'updated' && activity.type === 'contact details - social profile') {
      return `Social Profile Link was updated `;
    }
    else if (action == 'deleted' && activity.type === 'contact details - social profile') {
      return `Social Profile Link was removed`;
    }
    else if (action == 'created' && activity.type === 'contact details - email') {
      return `New Email ID was Added`;
    }
    else if (action == 'updated' && activity.type === 'contact details - email') {
      return `Email ID was updated`;
    }
    else if (action == 'deleted' && activity.type === 'contact details - email') {
      return `Email ID was removed`;
    }
    else if (action == 'created' && activity.type === 'contact details - contact number') {
      return `New Contact Number was Added`;
    }
    else if (action == 'updated' && activity.type === 'contact details - contact number') {
      return `Contact Number was updated`;
    }
    else if (action == 'deleted' && activity.type === 'contact details - contact number') {
      return `Contact Number was removed`;
    }
    else if((activity.tablename == 'candidatecontactdetail' || activity.tablename == 'candidate') && activity.type == 'Reveal Contact') {
      return  GlobalService.getAllCandidateActivityText(activity.updatedfieldname)
    }
    else if (activity.updatedfieldname == 'primaryemailid' || activity.updatedfieldname == 'primarycontactnumber') {
      return `Primary ${activity.type} has Added -  ${activity.newvalue}`;
    } else if (activity.action == 'pipl premium enrichment') {
      return 'Premium enrichment was done'
    } else if (activity.tablename) {
      if (activity.action == 'added') {
        return `Cv was added`
      } else if (activity.action == 'removed') {
        return `Cv was removed`
      }
    } 
    if (activity.action == 'details updated') {
      return activity.oldvalue
    }
  }

  addtags(data) {
    const modalRef = this.modalService.open(CandidateTagsComponent, { size: 'lg' as 'lg', centered: true });
    modalRef.componentInstance.candidatetoAdd = data ? data.basicdetails: []
    modalRef.componentInstance.bulkcandidates = this.selectedcandidate
    modalRef.componentInstance.passEntry.subscribe((x) => {
      if (x == 'updatetags') {
        this.toastmessage("Tags updated successfully", 'success')
        this.selected = false;
        this.isCandidateSelected = true;
        this.selectedcandidate = []
        this.getCandidateList();
      } else if(x == 'error') {
        this.toastmessage("Something went Wrong", 'error')
      }
    })
  }

  openCreateCandidate(){
    // document.getElementById("mySidebar").style.display = "block";
    // document.getElementById("myOverlay").style.display = "block";
    // this.candidateSubject.next();
    const ref = this.modalService.open(CreateCandidateNewComponent,{ size: 'lg' as 'lg', centered: true, backdrop: 'static', keyboard: false })
    ref.componentInstance.passEntry.subscribe((x) => {
      this.modalService.dismissAll();
      if (x == 'candidatecreated') {
        this.toastmessage('Candidate Created Succesfully', 'success')
      }else if( x == 'duplicatecandidate'){
        this.toastmessage('Duplicate Candidate ', 'error')
      } else if(x == 'errorinsavingfile'){
        this.toastmessage('Something went wrong while saving document', 'error')
      }
      else if (x == 'error') {
        this.toastmessage('Something went Wrong', 'error')
      }
      this.getCandidateList();
    })
    
  }

  getsliderdata(event, source?: string) {
    if(event == 'refresh') {
      this.getCandidateList(null, source);
    }
  }
  // getContactDetailsFromSlider(event){
  //   console.log('event 12',event);
  //   console.log('thi.candidatedetail', this.candidatedetails);
  //   this.candidatedetails = this.candidatedetails.map((item)=>{
  //     if(item?.basicdetails?.candidatenumber === event.candidatenumber){
  //       console.log('--->asdf');
  //       item['work_email'] =event?.obj?.work_email;
  //       item['personal_email'] = event?.obj?.personal_email;
  //       item['mobile_phone'] = event?.obj?.mobile_phone;
  //     }
  //     return item;
  //   })
  //   console.log('contatdetail from sloder', this.candidatedetails);
  // }

  openUrl(link, type) {
    if (link.startsWith("www.linkedin") || link.startsWith("www.facebook") || link.startsWith("www.twitter") || link.startsWith("www.github"))
      link = "https://" + link;
    else if (type == 'linkedin' && !(link.includes("https://www.linkedin") || link.includes("https://linkedin") || link.includes("https://in.linkedin") || link.includes("http://linkedin") || link.includes("http://www.linkedin")))
      link = "https://www." + link;
    else if (type == 'facebook' && !(link.includes("https://www.facebook") || link.includes("https://facebook") || link.includes("https://in.facebook") || link.includes("http://facebook") || link.includes("http://www.facebook")))
      link = "https://www." + link;
    else if (type == 'twitter' && !(link.includes("https://www.twitter") || link.includes("https://twitter") || link.includes("https://in.twitter") || link.includes("http://twitter") || link.includes("http://www.twitter")))
      link = "https://www." + link;
    else if (type == 'github' && !(link.includes("https://www.github") || link.includes("https://github") || link.includes("https://in.github") || link.includes("http://github") || link.includes("http://www.github")))
      link = "https://www." + link;
      else if (type == 'website'){
        link = "https://www." + link;
      }
    window.open(link, "_blank")
    
  }

  getCompanyInfo(data: any, type: any){
    if(data && !data.website){
      return;
    }
    // const loadn = document.querySelectorAll<HTMLElement>('.loading-screen-wrapper');
    // loadn[0].style.display = 'none'
    this.currentCompanyInformation = {}
    let companyName;
    companyName = data.companyname
    
    let companyData = {
      companynames:[companyName]
    }


    let website
    if(type == 'exp'){
      website = data.website
    }

    
    this.personSearchService.getCompanyLogo(companyData).subscribe((res: any) => {
      if(res.status == 'success' && res.message && res.message.length){
        let companyDetails = res.message[0]
        this.currentCompanyInformation['companylogo'] = companyDetails.companylogo
        this.currentCompanyInformation['name'] = companyDetails.name ? companyDetails.name : data.companyname
        this.currentCompanyInformation['industry'] = companyDetails.industry
        this.currentCompanyInformation['location'] = companyDetails?.location?.name
        this.currentCompanyInformation['size'] = companyDetails.size
        this.currentCompanyInformation['linkedin_url'] = companyDetails.linkedin_url
        this.currentCompanyInformation['website'] = companyDetails.website ? companyDetails.website : website
        this.currentCompanyInformation['tags'] = companyDetails.tags
        this.currentCompanyInformation['id'] = companyDetails.id
        this.currentCompanyInformation['key_id'] = res.message[0].id  
        
         // loadn[0].style.display = 'block'
        
      }
    });
// 
  
  }

  checkIfObjectIsEmpty(data){
    if(data && Object.keys(data).length == 0){
      return false;
    }
    return true;
  }

  exportToPDF(candidate: any) {
    if(!(candidate && candidate.basicdetails)) return;

    this.personSearchService.exportCandidateProfileToPDF({ candidatenumber: candidate.basicdetails.candidatenumber }).subscribe((res: any) => {
      if(res) {
        if(res.status === 'failure') {
          this.errorMessage = 'Error occured while exporting to PDF';
        } else {
          const blobFile = new Blob([res], { type: 'application/pdf' });
          const blobUrl = URL.createObjectURL(blobFile);
          const downloadLink = document.createElement("a");
          downloadLink.style.display = "none";
          document.body.appendChild(downloadLink);
          downloadLink.setAttribute("href", blobUrl);
          downloadLink.setAttribute("download", `${(candidate.basicdetails.firstname || '').replace(/\w\S*/g, (txt) => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase())} ${(candidate.basicdetails.lastname || '').replace(/\w\S*/g, (txt) => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase())}.pdf`);
          downloadLink.click();
          document.body.removeChild(downloadLink);
          this.successMessage = 'Exported to PDF successfully'
        }
        setTimeout(() => {
          this.successMessage = '';
          this.errorMessage = '';
        }, 5000);
      }
    });
  }
  //Add candidate to email campaign
  openAddToEmailCampaign(data) {
    if (data?.basicdetails?.candidatenumber) {
      this.selectedcandidate = [];
      this.selectedcandidate.push(data.basicdetails.candidatenumber);
    }
    const modalRef = this.modalService.open(this.addCandidateToEmailCampaign, { size: 'xs' as 'lg', centered: true, backdrop: 'static', keyboard: false });
  }

  onTypeAheadSearch(event: any): void {
    const query = event.target.value;
    this.emailCampaignService.getCampaigns({campaign_name: query,  created_by: this._localstorageservice.getItem('userdata').userid, 'status[]': [1,2]}).subscribe((data) => {
      this.campaignList = data['data'];
    });
  }

  // Add this function to handle the selection from the typeahead
  onCampaignSelected(value): void {
    this.selectedCampaign = value;
    this.campaign_input.setValue(value.campaign_name);
  }
  
  addToEmailCampaign() {
    this.isLoadingEmailCampaignApi = true;
    this.campaign_input.markAllAsTouched();
    if(this.campaign_input.valid && this.selectedCampaign){
      let unsubscribedCandidateCount = 0;
      let totalTarget = 0;
      const campaign_id = this.selectedCampaign?.campaign_id;
      let payloadArray = this.candidatedetails.map(x => {
        if (this.selectedcandidate.includes(x.basicdetails.candidatenumber)) {
          totalTarget++;
          if(x?.basicdetails?.is_unsubscribed){
            unsubscribedCandidateCount++;
            return;
          }
          let tempFirstName = (x.basicdetails?.firstname) ? x.basicdetails.firstname : '';
          let tempLastName = (x.basicdetails?.lastname) ? x.basicdetails.lastname : '';
          return {
            firstname: tempFirstName,
            target_name: tempFirstName + ' ' + tempLastName,
            target_id: x.candidateid,
            target_meta: JSON.stringify({
              "candidatenumber": x.basicdetails.candidatenumber,
              "title": x.basicdetails.jobtitle && x.basicdetails.jobtitle.length ? x.basicdetails.jobtitle : x.pastexperience[0],
              "elastic_id": (x.basicdetails?.elastic_id) ? x.basicdetails.elastic_id : null,
            }),
            target_email:null,
            is_active: true,
            created_on: new Date().toISOString(),
            updated_on: new Date().toISOString()
          };
        }
      }).filter(Boolean);
      payloadArray = payloadArray.filter(x => x);

      Promise.all(payloadArray.map(async (x) => {
        // Wait for the async operation to complete
        x.target_email = await this.getAllContactDetails(JSON.parse(x.target_meta).candidatenumber, this.getEmailPref(this.selectedCampaign['email_pref']));
        // Return the updated payload object to the Promise.all() call
        return x;
      })).then((updatedPayloadArray) => {
       
        //count total target emails in uploadPayloadArray store it in this.emailFoundCount

        this.emailFoundCount = 0;
        updatedPayloadArray.forEach(element => {
          if (element.target_email) {
            this.emailFoundCount++;
          }
        }
        );

        if(unsubscribedCandidateCount > 0 && updatedPayloadArray.length === 0){
          this.closeActiveModal();
          this.toastmessage("Unsubscribed from Email Campaign", 'error');
          return;
        }
        this.emailCampaignService.createTarget(campaign_id, updatedPayloadArray).subscribe((res: any) => {
          if (res.status == 'success') {
            this.isLoadingEmailCampaignApi = false;
            if (res.data && res.data.length) {
              this.toastmessage("Candidate added to email campaign successfully", 'success');
              this.closeActiveModal()

              
              if (updatedPayloadArray.length !== this.emailFoundCount){
                // new payload for openDetail modal that contains mapping of candidate number elastic_id and campaign_targe_id for bulk reveal
                const bulkRevealPayLoad = {
                  enrichedFrom: this.enrichedFromForReveal,
                  candidates:[],
                  campaign_id: campaign_id
                }
  
                res.data.map((arr)=>{
                  if(!arr?.target_email){
                    bulkRevealPayLoad.candidates.push(
                      { 
                        elastic_id: JSON.parse(arr?.target_meta || '{}')?.elastic_id,
                        // candidatenumber: JSON.parse(arr?.target_meta || '{}')?.candidatenumber,
                        campaign_target_id: arr.campaign_target_id
                      }
                    );
                  }
                });
                const modalObj = {
                  calledFor:'email-campaign',
                  total_target: totalTarget,
                  campaignDetails: this.selectedCampaign,
                  emailsFound: this.emailFoundCount,
                  payload: bulkRevealPayLoad,
                  campaign_id: campaign_id,
                  unsubscribedCandidateCount: unsubscribedCandidateCount
                }
               this.openDetailsModal(modalObj);
              }
            }
            else {
              this.closeActiveModal();
              if(unsubscribedCandidateCount){
                this.toastmessage("Unsubscribed from Email Campaign", 'error');
              }
              else this.toastmessage("Candidate already present in selected campaign", 'error');
            }

              this.selectedcandidate = [];
              this.candidatedetails.forEach((element, index) => {
              this.candidatedetails[index].selected = false;
              this.selectedcandidate = []
              this.selectedcandidateForNote = []
            })
            this.selected = false;
          }

          //show toast message if candidate addition failed
           else if(res.status=='failure') {
            this.closeActiveModal()
            this.toastmessage("candidate addition failed", "error");
          }
        });
      }).catch((error) => {
        this.toastmessage("An error occurred during candidate addition", "error");
        this.closeActiveModal()
        
      });
    }
    else{
      this.isLoadingEmailCampaignApi = false;
    }

  }
  getAllContactDetails(candidateid, type) {
    return new Promise((resolve, reject) => {
      let data = {
        "usernumber": this._localstorageservice.getItem('usernumber'),
        "candidatenumber": candidateid,
      };
  
      this.candidateservice.getContactDetails(data).subscribe(
        (res: any) => {
          if (res.status === 'success') {
            let email = null;
            if(type=='FirstPersonal'){
              email = res.data.emails.find((x) => x.isprimary && x.contactdetailcategory=='personal')?.contactdetail;
              if(!email) email = res.data.emails.find((x) => x.contactdetailcategory=='personal')?.contactdetail;
              if(!email) email = res.data.emails.find((x) => x.isprimary && x.contactdetailcategory=='professional')?.contactdetail;
              if(!email) email = res.data.emails.find((x) => x.contactdetailcategory=='professional')?.contactdetail;
            }
            else if(type=='FirstProfessional'){
              email = res.data.emails.find((x) => x.isprimary && x.contactdetailcategory=='professional')?.contactdetail;
              if(!email) email = res.data.emails.find((x) => x.contactdetailcategory=='professional')?.contactdetail;
              if(!email) email = res.data.emails.find((x) => x.isprimary && x.contactdetailcategory=='personal')?.contactdetail;
              if(!email) email = res.data.emails.find((x) => x.contactdetailcategory=='personal')?.contactdetail;
            }
            else{
               email = res.data.emails.find((x) => x.isprimary && x.contactdetailcategory==type)?.contactdetail;
               if(!email) email = res.data.emails.find((x) => x.contactdetailcategory==type)?.contactdetail;
            }
            if (email) {
              resolve(email);
            } else {
              // reject("email not found for the candidate.");
              resolve(null);
            }
          } else {
            reject("Error fetching contact details for the candidate.");
          }
        },
        (error) => {
          reject("An error occurred while fetching contact details.");
        }
      );
    });
  }

  /**
   * Function used to open Modal and to create Bulk Reveal payload
   */
  bulkRevealTalentpool() {
    const modalObj = {
      calledFor:'talentpool',
      total_target: this.candidatesWithoutContactNumber,
      campaignDetails: this.selectedCampaign,
      emailsFound:  0,
      payload: this.bulkRevealPayload(),
      campaign_id: null,
      unsubscribedCandidateCount: 0
    }
    this.openDetailsModal(modalObj);
  }

  /**
   * Function will return payload for bulk reveal and calculate the number of candidates without personsal email or contact number
   */
  bulkRevealPayload(){
    const bulkRevealPayLoad = {
      enrichedFrom: this.enrichedFromForReveal,
      talentpoolnumber: this.talentpoolnumber,
      candidates: []
    }
    this.selectedCandidateData = [];
    this.candidatesWithoutContactNumber = 0;
    this.candidatesWithoutContactInfo = 0;
    this.candidatedetails.map(x => {
      if (this.selectedcandidate.includes(x.basicdetails.candidatenumber)) {
        this.selectedCandidateData.push(x);
        if(!(x?.mobile_phone?.length) || !(x?.work_email?.length) || !(x?.personal_email?.length) ){
          this.candidatesWithoutContactInfo++;
          bulkRevealPayLoad.candidates.push({
            elastic_id: x.basicdetails?.elastic_id,
            talentpoolcandidatemappingid: x?.talentpoolMappingDetails?.talentpoolcandidatemappingid
          })
        }
        if(!x?.mobile_phone?.length){this.candidatesWithoutContactNumber++;}
      }
    });
    return bulkRevealPayLoad;
  }


  /**
   * Fuction used to know that, bulk reveal is still in process,
   * If yes then will show banner
   */
  bulkRevealBannerStatus(data = null) {
    this.talentpoolnumber &&
      this.talentpoolservice.bulkRevealStatus({ talentpoolnumber: this.talentpoolnumber }).subscribe((result: any) => {
        this.isBulkRevealInProcess = true;
        if(data){
          this.candidatedetails.map(x => {
            if (data.includes(x?.basicdetails?.elastic_id)) {
              x.talentpoolMappingDetails['bulkcontactrevealstatus'] = 1;
            }
          })
        }

      }, (err) => {
        this.isBulkRevealInProcess = false
      })
    this.fetchCurrentCredits();
  }

  fetchCurrentCredits() {
    this.transactionservice.fetchcurrentplandetails(this._localstorageservice.getItem('usernumber')).subscribe((res: any) => {
      if (res.status == 'success') {
        let userData = this._localstorageservice.getItem('userdata')
        userData['balancebasiccontactenrichmentcredits'] = res.data.balancebasiccontactenrichmentcredits
        this._localstorageservice.setItem('userdata', userData)
        this.transactionservice.createPaymentData();
      }
    })
  }
  
  /**
   * Remove Bulk Reveal banner
   */
  removeBulkProcessDiv(){
    const ele = document.getElementById("bulk-process");
    if(ele) ele.style.display = 'none';
    const ele2 = document.getElementById("bulk-talentpool-level");
    if(ele2) ele2.style.display = 'none';
  }

  openDetailsModal({ campaign_id, payload, emailsFound, total_target, calledFor, unsubscribedCandidateCount = 0, onTalentpoolLevel =  false }) {
    this.closeActiveModal();
    const modalRef = this.modalService.open(BulkRevealModalComponent, { size: 'xs' as 'lg', centered: true, backdrop: 'static', keyboard: false });
    modalRef.componentInstance.campaign_id = campaign_id;
    modalRef.componentInstance.payload = payload;
    modalRef.componentInstance.emailsFound = emailsFound;
    modalRef.componentInstance.campaignDetails = this.selectedCampaign;
    modalRef.componentInstance.total_target = total_target;
    modalRef.componentInstance.calledFor = calledFor;
    modalRef.componentInstance.talentpoolSelectedCandidate = {data: this.selectedCandidateData, onTalentpoolLevel: onTalentpoolLevel};
    modalRef.componentInstance.unsubscribedCandidateCount = unsubscribedCandidateCount;

    modalRef.componentInstance.bulkRevealModalData.subscribe((res) => {
      if (res.status === 'success') {
        if (res?.data && res?.data?.candidates?.length) {
          this.bulkRevealBannerStatus(res.data.candidates);
        }
        this.bulkRevealBannerTalentpoolLevel.showBanner = false;
      }
      else if(res.status === 'failure'){
        this.toastmessage("Something went wrong", 'error');
      }
    });
  }
  closeActiveModal(){
    this.campaign_input.markAsUntouched();
    this.campaign_input.markAsPristine();
    this.campaign_input.reset();
    this.bulkDownloadCSVSelectedOption = null; // reset bulk download csv selection
    this.modalService.dismissAll()
  }
  
  getEmailPref(data){
    if(data==1){
      return 'personal';
    }
    else if(data==2){
      return 'professional';
    }
    else if(data==3){
      return 'FirstPersonal';
    }
    else{
      return 'FirstProfessional';
    }
  }
}
